<p-dialog
    id="pickup-submitted-modal"
    pAutoFocus
    [autofocus]="true"
    [draggable]="false"
    [visible]="isVisible()"
    [modal]="true"
    [closable]="false"
    [resizable]="false">
    <ng-template pTemplate="header">
        <div id="pickup-submitted-modal-header">
            <div class="title">{{ 'dashboard.pickupSubmittedModal.title' | translate }}</div>

            <p-button
                id="close-modal-btn"
                icon="fa-regular fa-xmark"
                [rounded]="true"
                [severity]="'secondary'"
                [text]="true"
                (onClick)="closeModal()"></p-button>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <div id="pickup-submitted-modal-content">
            <p>
                <b>{{ pickupInfo()?.name }},</b>
            </p>
            <p
                [innerHTML]="
                    'dashboard.pickupSubmittedModal.info1' | translate: { noOfTubes: pickupInfo()?.noOfTubes }
                "></p>

            <div class="pickup-information">
                <p>
                    <b>{{ 'dashboard.pickupSubmittedModal.location' | translate }}:</b> {{ pickupInfo()?.location }}
                </p>
                <p>
                    <b>{{ 'dashboard.pickupSubmittedModal.days' | translate }}:</b> {{ pickupInfo()?.days }}
                </p>
                <p>
                    <b>{{ 'dashboard.pickupSubmittedModal.courierPickup' | translate }}:</b>
                    {{ pickupInfo()?.courierPickup }}
                </p>
                <p>
                    <b>{{ 'dashboard.pickupSubmittedModal.cutOffTime' | translate }}:</b> {{ pickupInfo()?.cutOffTime }}
                </p>
            </div>

            <p
                [innerHTML]="
                    'dashboard.pickupSubmittedModal.info2' | translate: { noOfTubes: pickupInfo()?.noOfTubes }
                "></p>
        </div>

        <img
            id="pickup-submitted-modal-watermark"
            [ngSrc]="'assets/images/illustrations/pickup-submitted-watermark.svg'"
            width="200"
            height="162"
            alt="" />
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="footer">
            <p-button
                id="close-pickup-submitted-modal-btn"
                [outlined]="true"
                [severity]="'secondary'"
                (click)="closeModal()"
                >{{ 'close' | translate }}</p-button
            >
            <p-button id="schedule-another-pickup-btn" (click)="scheduleAnotherPickup.emit()">{{
                'dashboard.pickupSubmittedModal.scheduleAnotherPickupBtn' | translate
            }}</p-button>
        </div>
    </ng-template>
</p-dialog>
